import { render, staticRenderFns } from "./AndroidHealthActivities.vue?vue&type=template&id=d59af5d4&scoped=true"
import script from "./AndroidHealthActivities.vue?vue&type=script&lang=js"
export * from "./AndroidHealthActivities.vue?vue&type=script&lang=js"
import style0 from "./AndroidHealthActivities.vue?vue&type=style&index=0&id=d59af5d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d59af5d4",
  null
  
)

export default component.exports